import createSagaMiddleware from "@redux-saga/core";
import { applyMiddleware, createStore } from "redux";

import rootSaga from '../redux/rootsaga';

import rootReducer from "../redux/reducers";

const sagaMiddleware = createSagaMiddleware();
export const Store = createStore(
    rootReducer,
    applyMiddleware(sagaMiddleware)
);
sagaMiddleware.run(rootSaga);